export default __webpack_public_path__ + "static/FAM0985M006-963a82b8fcf13211017d8e713f44fde6.jpg";